import $ from 'jquery';
import * as ScrollMagic from "scrollmagic";

import { gsap, TweenMax, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js"
import { CSSPlugin } from "gsap/CSSPlugin.js"

import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(CSSPlugin);

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const Scrolling = {
  init() {
    this.cache();
    this.events();
    this.fillSidebarText();
    this.initialLoading();
    this.parallaxModuleItems();
    this.counterAnimation();
    this.notebookHeaderAnimation();
  },
  cache(){
    this.$doc                 = $(document);
    this.$win                 = $(window);
    this.$scrollingActive     = false;
    this.$slidesCount         = $(".scroll-container__item").length;
    this.$prevSlideBtn        = $("#prevGalleryNav");
    this.$nextSlideBtn        = $("#nextGalleryNav");
    this.$activeItemIndex     = 0,
    this.$nextSlideIndex      = 1,
    this.$prevSlideIndex      = -1;
    this.$activeSlide         = $(".scroll-container__item[data-gallery-id="+this.$activeItemIndex+"]");
    this.$nextSlide           = $(".scroll-container__item[data-gallery-id="+this.$nextSlideIndex+"]");
    this.$prevSlide           = $(".scroll-container__item[data-gallery-id="+this.$prevSlideIndex+"]");
    this.$notebookBtn         = $(".js-card");
    this.$scrollDirection     = '';
  },
  events() {
    document.addEventListener('lazybeforeunveil', e => { ScrollTrigger.refresh() });
    this.$doc.on('click', '.js-tab', event => this.toggleScrolling(event));
    this.$prevSlideBtn.on('click', event => this.showPrevGallery(event, "navbar"));
    this.$nextSlideBtn.on('click', event => this.showNextGallery(event, "navbar"));
    this.$notebookBtn.on('click', event => this.scrollToGallery(event, "notebook"));
    this.$doc.on('click', '.js-intro', event => this.showIntro(event));
    this.$doc.on('click', '.reopen-galleries', event => this.reopenGalleries(event));
  },
  showIntro(){
    gsap.to(".initial-screen", { display: "block", margin: 0, ease: "power3.inOut", duration: 2 });
    $("#initialScreenNext").addClass('reopen-galleries');
  },
  reopenGalleries(){
    let { contineToGallery, $activeItemIndex, $nextSlideIndex, $prevSlideIndex } = this;
    $(".js-card.is-active").find(".notebook__sidebar__title").hide()
    $(".js-card.is-active").removeClass("is-active")
    $(".notebook__sidebar__card.js-card[data-gallery-id="+this.$activeItemIndex+"]").addClass("is-active")
    $(".js-card.is-active").find(".notebook__sidebar__title").slideToggle()
  },
  initialLoading(){
    if($(window).width() > 768) {
      // if it's loaded on desktop initially, init scrolling
      document.cookie = "mobileDevice=false";
      this.initScrolling();
      $("body").addClass("scrollingDisabled")
      this.mapAnimations();
    }
    else if($(window).width() <= 768) {
      document.cookie = "mobileDevice=true";
      $("body").addClass("scrollingDisabled")
    }
  },
  toggleScrolling(){
    if($("body").hasClass("notebook-open")) $("html").css("overflow", "hidden");
    else $("html").css("overflow", "auto");
  },
  showSidebarNav(){
    gsap.to($(".gallery-nav"), { duration: 1, delay: 0, x: -260, ease: "power3.inOut" });
  },
  hideSidebarNav(){
    gsap.to($(".gallery-nav"), { duration: 0.4, delay: 0, x: "100%", ease: "power3.inOut" });
  },
  scrollToGallery(e){
    let { $activeItemIndex } = this;
    $(".maps-container").hide();

    var $this = $(e.currentTarget);
    $(".js-card.is-active").find(".notebook__sidebar__title").hide();
    $(".js-card").removeClass("is-active");
    $this.addClass("is-active");
    $this.find(".notebook__sidebar__title").slideToggle("slow");

    let scrollToId = $this.attr('data-gallery-id');
    if(scrollToId > $activeItemIndex) this.showNextGallery(e, "notebook", scrollToId);
    else if(scrollToId < $activeItemIndex) this.showPrevGallery(e, "notebook", scrollToId);
    if($(".notebook").hasClass("is-open")) $(".notebook").removeClass("is-open");

    if($($this).hasClass('js-card--desktop')){
      $(".js-tab").removeAttr('aria-pressed');
      $(".js-tab").removeClass('is-open');
      $('.js-notebook').removeClass('is-open');
      $("body").removeClass('notebook-open');
      $("html").css("overflow", "auto");
    }
  },
  showNextGallery(e, navigationSource, id = null){
    $(".maps-container").hide();
    let { contineToGallery, $activeItemIndex, $nextSlideIndex, $prevSlideIndex } = this;
    contineToGallery = contineToGallery.bind(this);
    this.hideSidebarNav();
    if(navigationSource === 'notebook'){
      this.$nextSlide = $(".scroll-container__item[data-gallery-id="+id+"]");
      this.$nextSlideIndex = parseInt(id);
    }
    else{
      $(".js-card.is-active").find(".notebook__sidebar__title").hide();
      $(".js-card.is-active").removeClass("is-active")
      $(".notebook__sidebar__card.js-card[data-gallery-id="+this.$nextSlideIndex+"]").addClass("is-active");
      $(".js-card.is-active").find(".notebook__sidebar__title").slideToggle();
    }
    gsap.to($('.scroll-container__item.active section'), { duration: 3, opacity: 0, delay: 0, marginTop: "-150vh", ease: "Power4.easeOut" });
    gsap.to($(this.$activeSlide), {
      duration: 0, display: "none", delay: 0.5,
      onComplete: contineToGallery,
      onCompleteParams: ['down']
    })
    gsap.to($(this.$nextSlide), { delay: 0, duration: 0, display: "block", ease: "linear" });
  },
  showPrevGallery(e, navigationSource, id = null){
    $(".maps-container").hide();
    let { contineToGallery } = this;
    contineToGallery = contineToGallery.bind(this);
    this.hideSidebarNav();
    if(navigationSource === 'notebook'){
      this.$prevSlide = $(".scroll-container__item[data-gallery-id="+id+"]");
      this.$prevSlideIndex = parseInt(id);
    }
    else{
      $(".js-card.is-active").find(".notebook__sidebar__title").hide();
      $(".js-card.is-active").removeClass("is-active");
      $(".notebook__sidebar__card.js-card[data-gallery-id="+this.$prevSlideIndex+"]").addClass("is-active");
      $(".js-card.is-active").find(".notebook__sidebar__title").slideToggle();
    }
    gsap.to($('.scroll-container__item.active section'), { duration: 3, opacity: 0, delay: 0, marginTop: "100vh", ease: "Power4.easeOut" });
    gsap.to($(this.$prevSlide), { delay: 0.5, duration: 0, display: "block", ease: "linear" });
    gsap.to($(this.$activeSlide), {
      duration: 0, display: "none", delay: 0.5,
      onComplete: contineToGallery,
      onCompleteParams: ['up']
    })
  },
  contineToGallery(direction) {
    $(".maps-container").hide();
    gsap.to($('.scroll-container__item section'), { marginTop: "auto", marginBottom: "auto", delay: 0 });
    ScrollTrigger.getAll().forEach(ST => ST.scroll(0));
    ScrollTrigger.getAll().forEach(ST => ST.kill());
    $(this.$activeSlide).removeClass("active");
    if(direction === 'up') {
      $(this.$prevSlide).addClass("active");
      gsap.fromTo($('.scroll-container__item.active section'), { opacity: 0, y: -200 }, { duration: 1, y: 0, opacity: 1, ease: "power3.inOut" });
    }
    else {
      $(this.$nextSlide).addClass("active");
      gsap.fromTo($('.scroll-container__item.active section'), { opacity: 0, y: 200 }, { duration: 1, y: 0, opacity: 1, ease: "power3.inOut" });
    }
    this.parallaxModuleItems();
    this.reinitParameters(direction);
    this.initScrolling();
    this.fillSidebarText();
    this.counterAnimation();
    this.mapAnimations();
  },
  reinitParameters(direction) {
    if (direction === 'down') this.$activeItemIndex = this.$nextSlideIndex;
    else this.$activeItemIndex = this.$prevSlideIndex;
    this.$prevSlideIndex  = this.$activeItemIndex - 1;
    this.$nextSlideIndex  = this.$activeItemIndex + 1;
    this.$activeSlide     = $(".scroll-container__item[data-gallery-id="+this.$activeItemIndex+"]");
    this.$nextSlide       = $(".scroll-container__item[data-gallery-id="+this.$nextSlideIndex+"]");
    this.$prevSlide       = $(".scroll-container__item[data-gallery-id="+this.$prevSlideIndex+"]");
  },
  initScrolling() {
    let { showSidebarNav, hideSidebarNav, mapAnimations } = this;
    showSidebarNav = showSidebarNav.bind(this);

    ScrollTrigger.defaults({
      markers: false,
    });

    const this_container = $(this.$activeSlide).find('.template-content')[0];
    const $modules       = $(this_container).find('.gallery-module');
    const idxLast        = $modules.length - 1;
    let idx              = 0;
    let galleryWidth     = 0;
    let hidden           = false;
    let containerWidth   = $(this_container).outerWidth();

    $modules.each(function() {
      const elem = this;
      galleryWidth = galleryWidth + elem.scrollWidth;
      if ( idx == 0 ) elem.classList.add('gallery-module--first')
      if ( idx == idxLast ) elem.classList.add('gallery-module--last')
      idx++;
    });

    var templateWidth = $(this_container).outerWidth();
    const notebookWidth = $('.js-notebook')[0].clientWidth + $('.js-tab')[0].clientWidth;
    let navVisible = false;

    gsap.to(this_container, {
      x: () => -( (this_container.scrollWidth + notebookWidth) - document.documentElement.clientWidth ) + "px",
      ease: "none",
      scrollTrigger: {
        trigger: this_container,
        start: 0,
        scrub: true,
        invalidateOnRefresh: true,
        pin: true,
        end: () => "+=" + ( containerWidth ),
        onEnter: (st) => {
          hidden = false;
          gsap.to(".scrollToContinue", {  x: 0, opacity: "1", duration: 1, ease: "power1.out" });
          $("#scrollArrow").on('click', function(){
            $(this).unbind('click');
            gsap.to(this_container, { x: -400, duration: 1, ease: "power1.out" })
            setTimeout(function(){
              st.scroll(400);
            },1000)
          });
        },
        onUpdate: self => {
          if(self.direction == 1){
            this.$scrollDirection = 'right';
          }
          else if(self.direction === -1){
            this.$scrollDirection = 'left';
          }
          $('progress').attr('value', self.progress.toFixed(3)*100 + .5);
          if(self.progress.toFixed(3) > 0.980 && navVisible === false && self.direction === 1 ){
            showSidebarNav();
            navVisible = true;
          }
          else if(self.direction === -1  && navVisible === true){
            navVisible = false;
            hideSidebarNav();
          }
          if(self.progress.toFixed(3) > 0.020 && !hidden) {
            gsap.to(".scrollToContinue", {  x: 300, opacity: 0, duration: 1, ease: "power1.out" });
            hidden = true;
          }
          else if(self.progress.toFixed(3) < 0.020 && hidden){
            gsap.to(".scrollToContinue", {  x: 0, opacity: "1", duration: 1, ease: "power1.out" });
            hidden = false;
          }
        },
      }
    });
  },
  fillSidebarText(){
    var titlesArray = $('.title__text').map(function(){ return $.trim($(this).text()) }).get();
    if(this.$activeItemIndex === 0) {
      gsap.to("#prevGalleryNav", { duration: 0.2, opacity: 0, pointerEvents: "none", ease: "ease" });
    }
    else if(this.$activeItemIndex + 1 === this.$slidesCount) {
      gsap.to("#nextGalleryNav", { duration: 0, opacity: 0, pointerEvents: "none", ease: "ease" });
      gsap.to("#prevGalleryNav", { duration: 0, opacity: 1, pointerEvents: "all", ease: "ease" });
      gsap.to(".last-screen-slider", { duration: 0.2, display: "block", ease: "ease" });
    }
    else {
      gsap.to(".last-screen-slider", { duration: 0.2, display: "none", ease: "ease" });
      gsap.to("#prevGalleryNav", { duration: 0.2, delay: 1, opacity: 1, pointerEvents: "all", ease: "ease" });
      gsap.to("#nextGalleryNav", { duration: 0.2, delay: 1, opacity: 1, pointerEvents: "all", ease: "ease" });
    }
    setTimeout(() => {
      $("#nextGalleryNav h4").text(titlesArray[this.$nextSlideIndex]);
      $("#prevGalleryNav h4").text(titlesArray[this.$prevSlideIndex]);
    }, 500);
  },
  parallaxModuleItems(){
    // reverse all changes once gallery is switched
    $(".image-layout-one .img-top").css("left", "-5%");
    $(".image-layout-one .img-bottom").css("right", "-5%");
    $(".question__background img").css("margin-left", 0);
    $(".image-layout-five__side-image").css("margin-left", "-49%");

    // Module: Image Layout One
    if($(".scroll-container__item.active").find(".image-layout-one").length != 0){
      var controller = new ScrollMagic.Controller({vertical: false }); // unknown option 'tweenChanges' -revisit (option available for Scene)
      var topImage = TweenMax.to(".active .image-layout-one .img-top", { left: "-=25%" });
      var bottomImage = TweenMax.to(".active .image-layout-one .img-bottom", { right: "+=30%" });

      var sceneTop = new ScrollMagic.Scene({triggerElement: ".active .image-layout-one", triggerHook: 'onEnter', offset: 200, duration: 6000});
      var sceneBottom = new ScrollMagic.Scene({triggerElement: ".active .image-layout-one", triggerHook: 'onEnter', offset: 200, duration: 6000});
      sceneTop.setTween(topImage).addTo(controller);
      sceneBottom.setTween(bottomImage).addTo(controller);
    }

    // Module: Image Layout Five
    if($(".scroll-container__item.active").find(".image-layout-five").length != 0){
      var controller3 = new ScrollMagic.Controller({vertical: false });// unknown option 'tweenChanges' -revisit
      var sideImage = TweenMax.to(".active .image-layout-five__side-image", { marginLeft: "+=50%", ease: "Power4.easeOut" });
      var sceneSideImage = new ScrollMagic.Scene({triggerElement: ".active .image-layout-five", triggerHook: 'onEnter', offset: 250, duration: 5500});
      sceneSideImage.setTween(sideImage).addTo(controller3);
    }

    // Module: Question (w/ image)
    if($(".scroll-container__item.active").find(".question__background").length != 0){
      var controller2 = new ScrollMagic.Controller({vertical: false});// unknown option 'tweenChanges' -revisit
      $(".active .question__background").each(function(){
        var sceneBgImage = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 'onEnter',
          offset: 0,
          duration: 3000
        })
        .setTween(TweenMax.to(this, { left: "-=150" }))
        .addTo(controller2);
      });
    }
  },
  notebookHeaderAnimation(){
    var headerController = new ScrollMagic.Controller();
    var notebookHeader   = new TimelineMax();
    notebookHeader
      .to('.notebook__sidebar__full header', { duration: .6, margin: "-87px 0 0", ease: 'power2.inOut'})
      .to('.notebook__subheader', { duration: .6, margin: "-87px 0 0", ease: 'power2.inOut'}, 0)
    var headerScene = new ScrollMagic.Scene({
      triggerElement: ".notebook__sidebar__last",
      duration: 0,
      offset: 500,
      triggerHook: 'onEnter',
    });
    headerScene.setTween(notebookHeader).addTo(headerController);
  },
  counterAnimation() {
    if($(".scroll-container__item.active").find(".map1Point1").length != 0){
      var counterController = new ScrollMagic.Controller({vertical: false});

      // SCENE 1 for Counter
      var scene1 = new ScrollMagic.Scene({
        triggerElement: ".map1Point1",
        duration: 0,
        offset: 0,
        triggerHook: 'onEnter',
      });
      scene1.setTween(TweenMax.to('.title__gallery-year', 0.6, {opacity: 1, ease: 'power2.inOut'})).addTo(counterController);

      // SCENE 2 for Counter
      var scene2 = new ScrollMagic.Scene({
        triggerElement: ".CounterPoint2",
        duration: 200,
        offset: 0,
        triggerHook: 'onCenter',
      });
      scene2.setTween(TweenMax.to('.current-year-wrapper', 0.6, {opacity: 1, ease: 'power2.inOut'})).addTo(counterController);

      // SCENE 3 for Counter
      var scene3 = new ScrollMagic.Scene({
        triggerElement: ".CounterPoint2",
        duration: 600,
        offset: 0,
        triggerHook: 'onCenter',
      });
      scene3.setTween(TweenMax.fromTo('.current-year', 4, {textContent: 1607},{textContent: 1611,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1})).addTo(counterController);

      // SCENE 4 for Counter
      var scene4 = new ScrollMagic.Scene({
        triggerElement: ".map1Point3",
        duration: 400,
        offset: 400,
        triggerHook: 'onEnter',
      });
      scene4.setTween(TweenMax.to('.current-year', 4, {textContent: 1860,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1})).addTo(counterController);

      // SCENE 5 for Counter
      var scene5 = new ScrollMagic.Scene({
        triggerElement: ".CounterPoint3",
        duration: 400,
        offset: 400,
        triggerHook: 'onEnter',
      });
      scene5.setTween(TweenMax.to('.current-year', 4, {textContent: 1978,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1})).addTo(counterController);

      // SCENE 6 for Counter
      var animCounter = new TimelineMax();
      animCounter
        .to('.current-year', 1, {textContent: 1783,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1})
        .to('.current-year', 2, {textContent: 2010,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1},"+=2.5");
      var scene6 = new ScrollMagic.Scene({
        triggerElement: ".map2Point1",
        duration: 900,
        offset: 200,
        triggerHook: 'onEnter',
      });
      scene6.setTween(animCounter).addTo(counterController);

      // SCENE 7 for Counter
      // var scene7 = new ScrollMagic.Scene({
      //   triggerElement: ".map2Point1",
      //   duration: 500,
      //   offset: 300,
      //   triggerHook: 'onLeave',
      // });
      // scene7.setTween(TweenMax.to('.current-year', 4, {textContent: 2010,ease: 'power1.in',snap: { textContent: 1 }, stagger: 1})).addTo(counterController);
    }
  },

  mapAnimations(){
    let mapOne = $('.gallery1.map-one');
    let mapOneTwo = $('.gallery1.map-two');
    let mapFour = $('.gallery4.map-one');
    let mapFive = $('.gallery5.map-one');
    let mapTwelve = $('.gallery12.map-one');
    var pathGreen = $('#green-mark path.green-line');
    var pathBlue1 = $('#blue-mark path.blue-line1');
    var pathBlue2 = $('#blue-mark path.blue-line2');
    var pathPink = $('#pink-mark path.pink-line');
    var pathYellow1 = $('#yellow-mark path.yellow-line1');
    var pathYellow2 = $('#yellow-mark path.yellow-line2');
    var pathRed = $('#red-mark path.red-line');

    // I imagin calling this function ever time scrollingInit is called - because 'scroll-container__item.active' will change, so hide maps or fadeOut them
    $(mapOne).hide();
    $(mapOneTwo).hide();
    $(mapFour).hide();
    $(mapFive).hide();
    $(mapTwelve).hide();


    if(this.$activeItemIndex === 0 || this.$activeItemIndex === 3 || this.$activeItemIndex === 4 || this.$activeItemIndex === 11){
      setTimeout(function(){
        $(".maps-container").show();
        console.log('has map');
      }, 2000)
    }

    // ---- MAP 1 START ----
      var map1Controller = new ScrollMagic.Controller({vertical: false});

      // SCENE 1 for Map 1
      var animOneMapOne = new TimelineMax();
      animOneMapOne
        .to('.gallery1.map-one .bg-layer', 0.6, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery1.map-one .pin', 0.6, {opacity: 1, ease: 'power2.inOut'}, '+=0.4');

      var scene1_1 = new ScrollMagic.Scene({
        triggerElement: ".map1Point1",
        duration: 800,
        offset: 400,
        triggerHook: 'onEnter',
      });
      scene1_1.setTween(animOneMapOne.restart()).addTo(map1Controller);

      // SCENE 2 for Map 1
      var animTwoMapOne = new TimelineMax();
      animTwoMapOne
        .fromTo('.gallery1.map-one .pin2', 2.5, {scale: 1, opacity: 1,transformOrigin: 'center center', xPercent: -50, yPercent: -50},{scale: 1.5, opacity: 0, transformOrigin: 'center center', xPercent: -50, yPercent: -50, repeat: -1, ease: 'power3.out'} )
        .fromTo('.gallery1.map-one .pin3', 2.5, {scale: 1, opacity: 1,transformOrigin: 'center center', xPercent: -50, yPercent: -50},{scale: 1.5, opacity: 0, transformOrigin: 'center center', xPercent: -50, yPercent: -50, repeat: -1, ease: 'power3.out'}, '-=2.5' );

      var scene1_2 = new ScrollMagic.Scene({
        triggerElement: ".map1Point1",
        duration: 0,
        offset: 400,
        triggerHook: 'onCenter',
      });
      scene1_2.setTween(animTwoMapOne.restart()).addTo(map1Controller);

      // SCENE 3 for Map 1
      var animThreeMapOne = new TimelineMax();
      animThreeMapOne
        .fromTo('.gallery1.map-one .outline', 1, {opacity: 0}, {opacity: 1, ease: 'power2.inOut'})
        .fromTo('.gallery1.map-one .overlay', 1, {opacity: 0}, {opacity: 1, ease: 'power2.inOut'}, '-=0.6');

      var scene1_3 = new ScrollMagic.Scene({
        triggerElement: ".map1Point2",
        duration: 500,
        offset: 300,
        triggerHook: 'onCenter',
      });
      scene1_3.setTween(animThreeMapOne.restart()).addTo(map1Controller);

      // SCENE 4 for Map 1
      var animFourMapOne = new TimelineMax();
      animFourMapOne
        .addLabel("hideElems")
        .to('.gallery1.map-one .pin', 0.6, {opacity: 0, immediateRender: false, ease: 'power2.inOut'}, "hideElems")
        .to('.gallery1.map-one .outline', 1, {opacity: 0, immediateRender: false, ease: 'power2.inOut'}, "hideElems")
        .to('.gallery1.map-one .overlay', 1, {opacity: 0, immediateRender: false, ease: 'power2.inOut'}, "hideElems")
        .to('.gallery1.map-one .bg-layer', 1.5, {opacity: 0, immediateRender: false, ease: 'power2.inOut'});

      var scene1_4 = new ScrollMagic.Scene({
        triggerElement: ".map1Point3",
        duration: 500,
        offset: 300,
        triggerHook: 'onCenter',
      });
      scene1_4.setTween(animFourMapOne.restart()).addTo(map1Controller);

      // map1Controller.enabled(false);
    // -----  MAP 1 END -----


    // -----  MAP 2 START -----
      var map2Controller = new ScrollMagic.Controller({vertical: false});

      // SCENE 1 for Map 2
      var animOneMapTwo = new TimelineMax();
      animOneMapTwo
        .to('.gallery1.map-two .bg-layer', 0.6,{opacity: 1, ease: 'power2.inOut'})
        .to('.gallery1.map-two .outline1', 1, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery1.map-two .overlay1', 1, {opacity: 1, ease: 'power2.inOut'}, "-=0.8")
        .addLabel("fadeInRed", "+=2")
        .to('.gallery1.map-two .outline1', 1, {opacity: 0, ease: 'power2.inOut'}, "fadeInRed")
        .to('.gallery1.map-two .overlay1', 1, {opacity: 0, ease: 'power2.inOut'}, "fadeInRed")
        .to('.gallery1.map-two .outline2', 1, {opacity: 1, ease: 'power2.inOut'}, "fadeInRed")
        .to('.gallery1.map-two .overlay2', 1, {opacity: 1, ease: 'power2.inOut'}, "fadeInRed");

      var scene2_1 = new ScrollMagic.Scene({
        triggerElement: ".map2Point1",
        duration: 1000,
        offset: 300,
        triggerHook: 'onEnter',
      });
      scene2_1.setTween(animOneMapTwo.restart()).addTo(map2Controller);

      // SCENE 2 for Map 2
      var animTwoMapTwo = new TimelineMax();
      animTwoMapTwo
        .addLabel("fadeOut")
        .to('.gallery1.map-two .bg-layer', 0.5, {opacity: 0, immediateRender: false,ease: 'power2.inOut'},"fadeOut")
        .to('.gallery1.map-two .outline2', 0.5, {opacity: 0, immediateRender: false,ease: 'power2.inOut'},"fadeOut")
        .to('.gallery1.map-two .overlay2', 0.5, {opacity: 0, immediateRender: false,ease: 'power2.inOut'},"fadeOut");

      var scene2_2 = new ScrollMagic.Scene({
        triggerElement: ".map2Point2",
        duration: 0,
        offset: 100,
        triggerHook: 'onCenter'
      });
      scene2_2.setTween(animTwoMapTwo.restart()).addTo(map2Controller);

      // map2Controller.enabled(false);
    // -----  MAP 2 END -----


    // -----  MAP 4 START -----
      var map4Controller = new ScrollMagic.Controller({vertical: false});

      var animOneMapFour = new TimelineMax();
      animOneMapFour
        .to('.gallery4.map-one .bg-layer', 0.5, {opacity: 1, ease: 'power2.out'})
        .to('.gallery4.map-one .outline1', 0.5, {opacity: 1, ease: 'power2.out'})
        .to('.gallery4.map-one .overlay1', 0.5, {opacity: 0.5, ease: 'power2.out'},'-=0.5')
        .set(pathGreen, {strokeDasharray:360})
        .set(pathBlue1, {strokeDasharray:440})
        .set(pathBlue2, {strokeDasharray:450})
        .set(pathPink, {strokeDasharray:440})
        .set(pathYellow1, {strokeDasharray:440})
        .set(pathYellow2, {strokeDasharray:620})
        .set(pathRed, {strokeDasharray:700})
        .to('.gallery4.map-one #green-mark',0.01,{opacity: 1, ease: 'power2.out'})
        .fromTo(pathGreen, 3,{strokeDashoffset:360},{strokeDashoffset:0, opacity: 1, ease: 'power2.out'})
        .to('.gallery4.map-one #green-mark .green-arrow', 0.5,{opacity: 1, ease: 'power2.out'}, "-=1")
        .to('.gallery4.map-one .green-legend',0.5,{opacity: 1, ease: 'power2.out'}, "-=2")
        .to('.gallery4.map-one .outline2', 1, {opacity: 1, ease: 'power2.out'})
        .to('.gallery4.map-one .overlay2', 1, {opacity: 0.5, ease: 'power2.out'},"-=1");
        // .addLabel("fadeOutGreen", "+=1")
        // .to('.gallery4.map-one #green-mark',1,{opacity: 0, ease: 'power2.out'},"fadeOutGreen")
        // .to(pathGreen,1,{opacity: 0, ease: 'power2.out'},"fadeOutGreen")
        // .to('.gallery4.map-one #green-mark .green-arrow',1,{opacity: 0, ease: 'power2.out'},"fadeOutGreen");

      var animTwoMapFour = new TimelineMax();
      animTwoMapFour
        .addLabel("show-marks")
        .to('.gallery4.map-one #blue-mark',0.01,{opacity: 1, ease: 'power2.out'},"show-marks")
        .to('.gallery4.map-one #yellow-mark',0.01,{opacity: 1, ease: 'power2.out'},"show-marks")
        .to('.gallery4.map-one #pink-mark',0.01,{opacity: 1, ease: 'power2.out'},"show-marks")
        .to('.gallery4.map-one #red-mark',0.01,{opacity: 1, ease: 'power2.out'},"show-marks")

        .addLabel("startAllLines", "+=0.5")
        .fromTo(pathBlue1, 3,{strokeDashoffset:440}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .fromTo(pathBlue2, 3,{strokeDashoffset:450}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .to('.gallery4.map-one #blue-mark .blue-arrow', 0.5,{opacity: 1, ease: 'power2.out'}, "-=1")
        .to('.gallery4.map-one .blue-legend',0.5,{opacity: 1, ease: 'power2.out'}, "startAllLines")


        // .addLabel("startYellowLine", "+=0.5")
        .fromTo(pathYellow1, 3,{strokeDashoffset:440}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .fromTo(pathYellow2, 3,{strokeDashoffset:620}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .to('.gallery4.map-one #yellow-mark .yellow-arrow', 0.5,{opacity: 1, ease: 'power2.out'}, "-=1")
        .to('.gallery4.map-one .yellow-legend',0.5,{opacity: 1, ease: 'power2.out'}, "startAllLines")


        // .addLabel("startPinkLine", "+=0.5")
        .fromTo(pathPink, 3,{strokeDashoffset:440}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .to('.gallery4.map-one #pink-mark .pink-arrow', 0.8,{opacity: 1, ease: 'power2.out'}, '-=1')
        .to('.gallery4.map-one .pink-legend',0.5,{opacity: 1, ease: 'power2.out'}, "startAllLines")

        // .addLabel("startRedLine", "+=0.5")
        .fromTo(pathRed, 3,{strokeDashoffset:700}, {strokeDashoffset:0, opacity: 1, ease: 'power2.out'}, "startAllLines")
        .to('.gallery4.map-one #red-mark .red-arrow', 0.8,{opacity: 1, ease: 'power2.out'}, '-=1')
        .to('.gallery4.map-one .red-legend',0.5,{opacity: 1, ease: 'power2.out'}, "startAllLines");

      var animThreeMapFour = new TimelineMax();
      animThreeMapFour
        .addLabel("changeToRed", "+=1")
        .to('.gallery4.map-one .outline1', 1, {opacity: 0, ease: 'power2.out'},"changeToRed")
        .to('.gallery4.map-one .overlay1', 1, {opacity: 0, ease: 'power2.out'},"changeToRed")
        .to('.gallery4.map-one .outline3', 1, {opacity: 1, ease: 'power2.out'},"changeToRed")
        .to('.gallery4.map-one .overlay3', 1, {opacity: 0.5, ease: 'power2.out'},"changeToRed");

      var animFourMapFour = new TimelineMax();
      animFourMapFour
        .addLabel("fadeOut", "+=1")
        .to(pathGreen,1,{opacity: 0, ease: 'power2.out'},"fadeOut")
        .to('.gallery4.map-one #green-mark .green-arrow',1,{opacity: 0, ease: 'power2.out'},"fadeOut")
        .to('.gallery4.map-one #blue-mark',1,{opacity: 0, ease: 'power2.out'},"fadeOut")
        .to(pathBlue1,1,{opacity: 0, ease: 'power2.out'},"fadeOut")
        .to(pathBlue2,1,{opacity: 0, ease: 'power2.out'},"fadeOut")
        .to('.gallery4.map-one #blue-mark .blue-arrow',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #yellow-mark',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to(pathYellow1,1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to(pathYellow2,1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #yellow-mark .yellow-arrow',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #pink-mark',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to(pathPink,1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #pink-mark .pink-arrow',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #red-mark',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to(pathRed,1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one #red-mark .red-arrow',1,{opacity: 0, ease: 'power2.out'}, "fadeOut")
        .to('.gallery4.map-one .legend-wrapper',1,{opacity: 0, ease: 'power2.out'});

      // SCENE 1 for Map 4
      var scene4_1 = new ScrollMagic.Scene({
        triggerElement: ".map4Point1",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter',
      });
      scene4_1.setTween(animOneMapFour).addTo(map4Controller);

      // SCENE 2 for Map 4
      var scene4_2 = new ScrollMagic.Scene({
        triggerElement: ".map4Point2",
        duration: 0,
        offset: 100,
        triggerHook: 'onEnter'
      });
      scene4_2.setTween(animTwoMapFour).addTo(map4Controller);

      // SCENE 3 for Map 4
      var scene4_3 = new ScrollMagic.Scene({
        triggerElement: ".map4Point3",
        duration: 0,
        offset: 100,
        triggerHook: 'onCenter'
      });
      scene4_3.setTween(animThreeMapFour).addTo(map4Controller);

      // SCENE 4 for Map 4
      var scene4_4 = new ScrollMagic.Scene({
        triggerElement: ".map4Point4",
        duration: 0,
        offset: 100,
        triggerHook: 'onCenter'
      });
      scene4_4.setTween(animFourMapFour).addTo(map4Controller);

      // map4Controller.enabled(false);
    // -----  MAP 4 END -----


    // -----  MAP 5 START -----
      var map5Controller = new ScrollMagic.Controller({vertical: false});

      // SCENE 1 for Map 5
      var animOneMapFive = new TimelineMax();
      animOneMapFive
        .to('.gallery5.map-one .bg-layer', 0.2, {opacity: 1, ease: 'power2.inOut'});
      var scene5_1 = new ScrollMagic.Scene({
        triggerElement: ".map5Point1",
        duration: 0,
        offset: 300,
        triggerHook: 'onEnter',
      });
      scene5_1.setTween(animOneMapFive).addTo(map5Controller);

      // SCENE 2 for Map 5
      var animTwoMapFive = new TimelineMax();
      animTwoMapFive
        .addLabel("red overlay")
        .to('.gallery5.map-one .outline1', 0.6, {opacity: 1, ease: 'power2.inOut'},"red overlay")
        .to('.gallery5.map-one .overlay1', 0.6, {opacity: 1, ease: 'power2.inOut'},"red overlay")
        .addLabel("red mont","+=0.5")
        .to('.gallery5.map-one .outline2', 0.6, {opacity: 1, ease: 'power2.inOut'},"red mont")
        .to('.gallery5.map-one .overlay2', 0.6, {opacity: 1, ease: 'power2.inOut'},"red mont");
      var scene5_2 = new ScrollMagic.Scene({
        triggerElement: ".map5Point2",
        duration: 0,
        offset: 300,
        triggerHook: 'onEnter'
      });
      scene5_2.setTween(animTwoMapFive).addTo(map5Controller);

      // SCENE 3 for Map 5
      var animThreeMapFive = new TimelineMax();
      animThreeMapFive
        .addLabel("blue overlay")
        .to('.gallery5.map-one .outline3', 0.6, {opacity: 1, ease: 'power2.inOut'},"blue overlay")
        .to('.gallery5.map-one .overlay3', 0.6, {opacity: 1, ease: 'power2.inOut'},"blue overlay");
      var scene5_3 = new ScrollMagic.Scene({
        triggerElement: ".map5Point3",
        duration: 0,
        offset: 300,
        triggerHook: 'onEnter'
      });
      scene5_3.setTween(animThreeMapFive).addTo(map5Controller);

      // map5Controller.enabled(false);
    // -----  MAP 5 END -----

    // -----  MAP 12 START -----
      var map12Controller = new ScrollMagic.Controller({vertical: false});

      // SCENE 1 for Map 12
      var animOneMap12 = new TimelineMax();
      animOneMap12
        .to('.gallery12.map-one .bg-layer', 0.2, {opacity: 1, ease: 'power2.inOut'});
      var scene12_1 = new ScrollMagic.Scene({
        triggerElement: ".map12Point1",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter',
      });
      scene12_1.setTween(animOneMap12).addTo(map12Controller);

      // SCENE 2 for Map 12
      var animTwoMap12 = gsap.timeline();
      animTwoMap12
        .to('.gallery12.map-one .outline1', 0.6, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery12.map-one .overlay1', 0.6, {opacity: 1, ease: 'power2.inOut'}, "-=0.6");
      var scene12_2 = new ScrollMagic.Scene({
        triggerElement: ".map12Point2",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_2.setTween(animTwoMap12).addTo(map12Controller);

      // SCENE 3 for Map 12
      var animThreeMap12 = gsap.timeline();
      animThreeMap12
        .to('.gallery12.map-one .outline2', 0.6, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery12.map-one .overlay2', 0.6, {opacity: 1, ease: 'power2.inOut'}, "-=0.6");
      var scene12_3 = new ScrollMagic.Scene({
        triggerElement: ".map12Point3",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_3.setTween(animThreeMap12).addTo(map12Controller);

      // SCENE 4 for Map 12
      var animFourMap12 = gsap.timeline();
      animFourMap12
        .to('.gallery12.map-one .outline3', 0.6, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery12.map-one .overlay3', 0.6, {opacity: 1, ease: 'power2.inOut'}, "-=0.6");
      var scene12_4 = new ScrollMagic.Scene({
        triggerElement: ".map12Point4",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_4.setTween(animFourMap12).addTo(map12Controller);

      // SCENE 5 for Map 12
      var animFiveMap12 = gsap.timeline();
      animFiveMap12
        .to('.gallery12.map-one .outline4', 0.6, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery12.map-one .overlay4', 0.6, {opacity: 1, ease: 'power2.inOut'}, "-=0.6");
      var scene12_5 = new ScrollMagic.Scene({
        triggerElement: ".map12Point5",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_5.setTween(animFiveMap12).addTo(map12Controller);

      // SCENE 6 for Map 12
      var animSixMap12 = gsap.timeline();
      animSixMap12
        .to('.gallery12.map-one .pin12', 0.6, {opacity: 1, ease: 'power2.inOut'}, '+=0.4')
      var scene12_6 = new ScrollMagic.Scene({
        triggerElement: ".map12Point6",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_6.setTween(animSixMap12).addTo(map12Controller);

      // SCENE 7 for Map 12
      var animSevenMap12 = gsap.timeline();
      animSevenMap12
        .to('.gallery12.map-one .outline5', 0.4, {opacity: 1, ease: 'power2.inOut'})
        .to('.gallery12.map-one .overlay5', 0.6, {opacity: 1, ease: 'power2.inOut'}, "-=0.6");
      var scene12_7 = new ScrollMagic.Scene({
        triggerElement: ".map12Point7",
        duration: 0,
        offset: 300,
        triggerHook: 'onCenter'
      });
      scene12_7.setTween(animSevenMap12).addTo(map12Controller);

      // map12Controller.enabled(false);
    // -----  MAP 12 END -----

    // Global Scroll Direction variable
    let bindThis = this;

    // scene1_1.on("update", function (event) {
    //     console.log(bindThis.$scrollDirection);
    //   });

    // Reset all galleries with no maps
    if($(".scroll-container__item.active").find(".noMapGallery").length != 0){
      map1Controller = map1Controller.destroy(true);
      map2Controller = map2Controller.destroy(true);
      map4Controller = map4Controller.destroy(true);
      map5Controller = map5Controller.destroy(true);
      map12Controller = map12Controller.destroy(true);

      animOneMapOne.progress(0).clear();
      animTwoMapOne.progress(0).clear();
      animThreeMapOne.progress(0).clear();
      animFourMapOne.progress(0).clear();
      animOneMapTwo.progress(0).clear();
      animTwoMapTwo.progress(0).clear();
      animOneMapFour.progress(0).clear();
      animTwoMapFour.progress(0).clear();
      animThreeMapFour.progress(0).clear();
      animFourMapFour.progress(0).clear();
      animOneMapFive.progress(0).clear();
      animTwoMapFive.progress(0).clear();
      animThreeMapFive.progress(0).clear();
      animOneMap12.progress(0).clear();
      animTwoMap12.progress(0).clear();
      animThreeMap12.progress(0).clear();
      animFourMap12.progress(0).clear();
      animFiveMap12.progress(0).clear();
      animSixMap12.progress(0).clear();
      animSevenMap12.progress(0).clear();

      scene1_1.remove();
      scene1_2.remove();
      scene1_3.remove();
      scene1_4.remove();
      scene2_1.remove();
      scene2_2.remove();
      scene4_1.remove();
      scene4_2.remove();
      scene4_3.remove();
      scene4_4.remove();
      scene5_1.remove();
      scene5_2.remove();
      scene5_3.remove();
      scene12_1.remove();
      scene12_2.remove();
      scene12_3.remove();
      scene12_4.remove();
      scene12_5.remove();
      scene12_6.remove();
      scene12_7.remove();

      $(mapTwelve).hide();
      $(mapOne).hide();
      $(mapOneTwo).hide();
      $(mapFour).hide();
      $(mapFive).hide();
    }
    if($(".scroll-container__item.active").find(".map1Point1").length != 0 && $(".scroll-container__item.active").find(".map2Point1").length != 0){
      map4Controller = map4Controller.destroy(true);
      map5Controller = map5Controller.destroy(true);
      map12Controller = map12Controller.destroy(true);

      animOneMapFour.progress(0).clear();
      animTwoMapFour.progress(0).clear();
      animThreeMapFour.progress(0).clear();
      animFourMapFour.progress(0).clear();
      animOneMapFive.progress(0).clear();
      animTwoMapFive.progress(0).clear();
      animThreeMapFive.progress(0).clear();
      animOneMap12.progress(0).clear();
      animTwoMap12.progress(0).clear();
      animThreeMap12.progress(0).clear();
      animFourMap12.progress(0).clear();
      animFiveMap12.progress(0).clear();
      animSixMap12.progress(0).clear();
      animSevenMap12.progress(0).clear();

      scene4_1.remove();
      scene4_2.remove();
      scene4_3.remove();
      scene4_4.remove();
      scene5_1.remove();
      scene5_2.remove();
      scene5_3.remove();
      scene12_1.remove();
      scene12_2.remove();
      scene12_3.remove();
      scene12_4.remove();
      scene12_5.remove();
      scene12_6.remove();
      scene12_7.remove();

      $(mapOne).hide();
      $(mapOneTwo).hide();
      $(mapFour).hide();
      $(mapFive).hide();
      $(mapTwelve).hide();

      // MAP 1
      scene1_1.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapOne).show();
        }
      });
      scene1_1.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapOne).hide();
          // console.log("scene1_1.on leave end left hide");
        }
      });
      scene1_4.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapOne).show();
          // console.log("scene1_4.on enter start left show");
        }
      });
      scene1_4.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapOne).hide();
          // console.log("scene1_4.on leave end right hide");
        }
      });

      // MAP 2
      scene2_1.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapOneTwo).show();
        }
      });
      scene2_2.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapOneTwo).hide();
        }
      });
      scene2_1.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapOneTwo).hide();
        }
      });
      scene2_2.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapOneTwo).show();
        }
      });
    }
    if($(".scroll-container__item.active").find(".map4Point1").length != 0){
      map1Controller = map1Controller.destroy(true);
      map2Controller = map2Controller.destroy(true);
      map5Controller = map5Controller.destroy(true);
      map12Controller = map12Controller.destroy(true);

      animOneMapOne.progress(0).clear();
      animTwoMapOne.progress(0).clear();
      animThreeMapOne.progress(0).clear();
      animFourMapOne.progress(0).clear();
      animOneMapTwo.progress(0).clear();
      animTwoMapTwo.progress(0).clear();
      animOneMapFive.progress(0).clear();
      animTwoMapFive.progress(0).clear();
      animThreeMapFive.progress(0).clear();
      animOneMap12.progress(0).clear();
      animTwoMap12.progress(0).clear();
      animThreeMap12.progress(0).clear();
      animFourMap12.progress(0).clear();
      animFiveMap12.progress(0).clear();
      animSixMap12.progress(0).clear();
      animSevenMap12.progress(0).clear();


      scene1_1.remove();
      scene1_2.remove();
      scene1_3.remove();
      scene1_4.remove();
      scene2_1.remove();
      scene2_2.remove();
      scene5_1.remove();
      scene5_2.remove();
      scene5_3.remove();
      scene12_1.remove();
      scene12_2.remove();
      scene12_3.remove();
      scene12_4.remove();
      scene12_5.remove();
      scene12_6.remove();
      scene12_7.remove();

      $(mapFour).hide();
      $(mapOne).hide();
      $(mapOneTwo).hide();
      $(mapFive).hide();
      $(mapTwelve).hide();

      scene4_1.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapFour).show();
        }
      });
      scene4_4.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapFour).hide();
        }
      });
      scene4_1.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapFour).hide();
        }
      });
      scene4_4.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapFour).show();
        }
      });
    }
    if($(".scroll-container__item.active").find(".map5Point1").length != 0){
      map1Controller = map1Controller.destroy(true);
      map2Controller = map2Controller.destroy(true);
      map4Controller = map4Controller.destroy(true);
      map12Controller = map12Controller.destroy(true);

      animOneMapOne.progress(0).clear();
      animTwoMapOne.progress(0).clear();
      animThreeMapOne.progress(0).clear();
      animFourMapOne.progress(0).clear();
      animOneMapTwo.progress(0).clear();
      animTwoMapTwo.progress(0).clear();
      animOneMapFour.progress(0).clear();
      animTwoMapFour.progress(0).clear();
      animThreeMapFour.progress(0).clear();
      animFourMapFour.progress(0).clear();
      animOneMap12.progress(0).clear();
      animTwoMap12.progress(0).clear();
      animThreeMap12.progress(0).clear();
      animFourMap12.progress(0).clear();
      animFiveMap12.progress(0).clear();
      animSixMap12.progress(0).clear();
      animSevenMap12.progress(0).clear();

      scene1_1.remove();
      scene1_2.remove();
      scene1_3.remove();
      scene1_4.remove();
      scene2_1.remove();
      scene2_2.remove();
      scene4_1.remove();
      scene4_2.remove();
      scene4_3.remove();
      scene4_4.remove();
      scene12_1.remove();
      scene12_2.remove();
      scene12_3.remove();
      scene12_4.remove();
      scene12_5.remove();
      scene12_6.remove();
      scene12_7.remove();

      $(mapFive).hide();
      $(mapOne).hide();
      $(mapOneTwo).hide();
      $(mapFour).hide();
      $(mapTwelve).hide();

      scene5_1.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapFive).show();
        }
      });
      scene5_3.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapFive).hide();
        }
      });
      scene5_1.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapFive).hide();
        }
      });
      scene5_3.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapFive).show();
        }
      });
    }
    if($(".scroll-container__item.active").find(".map12Point1").length != 0){
      map1Controller = map1Controller.destroy(true);
      map2Controller = map2Controller.destroy(true);
      map4Controller = map4Controller.destroy(true);
      map5Controller = map5Controller.destroy(true);

      animOneMapOne.progress(0).clear();
      animTwoMapOne.progress(0).clear();
      animThreeMapOne.progress(0).clear();
      animFourMapOne.progress(0).clear();
      animOneMapTwo.progress(0).clear();
      animTwoMapTwo.progress(0).clear();
      animOneMapFour.progress(0).clear();
      animTwoMapFour.progress(0).clear();
      animThreeMapFour.progress(0).clear();
      animFourMapFour.progress(0).clear();
      animOneMapFive.progress(0).clear();
      animTwoMapFive.progress(0).clear();
      animThreeMapFive.progress(0).clear();

      scene1_1.remove();
      scene1_2.remove();
      scene1_3.remove();
      scene1_4.remove();
      scene2_1.remove();
      scene2_2.remove();
      scene4_1.remove();
      scene4_2.remove();
      scene4_3.remove();
      scene4_4.remove();
      scene5_1.remove();
      scene5_2.remove();
      scene5_3.remove();

      $(mapTwelve).hide();
      $(mapOne).hide();
      $(mapOneTwo).hide();
      $(mapFour).hide();
      $(mapFive).hide();

      scene12_1.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapTwelve).show();
        }
      });
      scene12_7.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'right') {
          $(mapTwelve).hide();
        }
      });
      scene12_1.on("leave end", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapTwelve).hide();
        }
      });
      scene12_7.on("enter start", function (event) {
        if(bindThis.$scrollDirection == 'left') {
          $(mapTwelve).show();
        }
      });
    }
  }
}

Scrolling.init()
